import React from 'react';
import { Slide } from '../../components/deck/Slide';
import { Eyebrow, INK, Label, Reveal, Title } from '../../components/deck/Type';
const SERIF = {
  fontFamily: 'var(--font-serif)'
} as const;
const sources = ['Paid data', 'Partner data', 'Public data', 'Client data', 'Proprietary StartupFuel data'];
const criteria = ['Accuracy', 'Coverage', 'Freshness', 'Speed', 'Reliability', 'Cost'];
const dataset = [{
  value: '25,000+',
  label: 'Companies in the StartupFuel dataset',
  tone: '#F4F7FC'
}, {
  value: '20,000',
  label: 'Scraped + vetted',
  tone: INK.violet
}, {
  value: '3,000',
  label: 'Founder self-submitted',
  tone: INK.blue
}, {
  value: '2,000',
  label: 'Via community partnerships',
  tone: INK.emerald
}];
function Arrow() {
  return <span className="self-center text-[1.5cqw] text-white/30" aria-hidden data-id="element-171" data-mp="2hsy7q3jxyk3">
      →
    </span>;
}
export function CuratedDataSlide() {
  return <Slide data-id="element-172" data-mp="bir6wloxqu90">
      <Eyebrow data-id="element-173" data-mp="bkc12a7c8b6c">Data infrastructure</Eyebrow>
      <Title className="mt-[2.2cqh]" data-id="element-174" data-mp="bh7rsyf0mp8t">Not more data. The right data for every decision.</Title>

      <div className="mt-auto flex items-stretch gap-[1.4cqw]" data-id="element-175" data-mp="1p06m4g41hf1v">
        <div className="flex w-[20cqw] shrink-0 flex-col gap-[1cqh]" data-id="element-176" data-mp="1kzmtnpueuzm2">
          {sources.map((s, i) => <Reveal key={s} delay={0.04 * i} className={i === sources.length - 1 ? 'border border-[#D8A55A]/50 bg-[#D8A55A]/[0.07] px-[1.2cqw] py-[1.7cqh] text-[1.05cqw] text-[#F4F7FC]' : 'border border-white/10 px-[1.2cqw] py-[1.7cqh] text-[1.05cqw] text-[#C3CBD9]'} data-id="element-177" data-mp="1g2e7le656bfj" data-mpi={i}>
              {s}
            </Reveal>)}
        </div>

        <Arrow data-id="element-178" data-mp="1u1nko4z1wpfa" />

        <Reveal delay={0.2} className="flex flex-1 flex-col justify-center border border-[#3B8CFF]/50 bg-[#3B8CFF]/[0.07] p-[1.8cqw]" data-id="element-179" data-mp="1u25q9s7lsfzv">
          <Label tone={INK.blue} data-id="element-180" data-mp="2ri2u64fhh8ft">DGPT data router</Label>
          <p className="mt-[1.2cqh] text-[2cqw] leading-tight text-[#F4F7FC]" style={SERIF} data-id="element-181" data-mp="2mpjk3hg08vfr">
            Each source selected and continuously evaluated on
          </p>
          <div className="mt-[2.6cqh] grid grid-cols-3 gap-[0.6cqw]" data-id="element-182" data-mp="ou37gx7aenjx">
            {criteria.map(c => <span key={c} className="border border-white/12 py-[1.3cqh] text-center text-[1cqw] text-[#DCE3EE]" data-id="element-183" data-mp="b2pszxo8kfvr">
                {c}
              </span>)}
          </div>
        </Reveal>

        <Arrow data-id="element-184" data-mp="14s375qqab11" />

        <Reveal delay={0.3} className="flex w-[17cqw] shrink-0 flex-col justify-center border-t-2 border-[#2FBE8F] bg-white/[0.02] p-[1.5cqw]" data-id="element-185" data-mp="148vehusl30q">
          <Label tone={INK.emerald} data-id="element-186" data-mp="64wm12f3zhuf">Output</Label>
          <p className="mt-[1.4cqh] text-[1.6cqw] leading-tight text-[#F4F7FC]" style={SERIF} data-id="element-187" data-mp="3o9rjb9nt7eqi">
            Verified, structured intelligence
          </p>
          <p className="mt-[1.4cqh] text-[0.92cqw] text-[#8B95A8]" data-id="element-188" data-mp="3taf6tlctxdfz">With source citations</p>
        </Reveal>
      </div>

      <Reveal delay={0.4} className="mt-[3.4cqh] grid grid-cols-4 border-t border-white/12 pt-[2.2cqh]" data-id="element-189" data-mp="1rgxyefgvk8k6">
        {dataset.map((d, i) => <div key={d.label} className={i === 0 ? '' : 'border-l border-white/10 pl-[1.4cqw]'} data-id="element-190" data-mp="21lxwyrrtwi32" data-mpi={i}>
            <p className="text-[2cqw] leading-none" style={{
          ...SERIF,
          color: d.tone
        }} data-id="element-191" data-mp="1wmuqd2w7a3sz">
              {d.value}
            </p>
            <div className="mt-[1cqh]" data-id="element-192" data-mp="2aehqjdt9jwh1">
              <Label data-id="element-193" data-mp="25mq6zn8iyr0e">{d.label}</Label>
            </div>
          </div>)}
      </Reveal>
    </Slide>;
}